import { render, staticRenderFns } from "./cellCenter.vue?vue&type=template&id=139a9ed0&scoped=true&"
import script from "./cellCenter.vue?vue&type=script&lang=js&"
export * from "./cellCenter.vue?vue&type=script&lang=js&"
import style0 from "./cellCenter.vue?vue&type=style&index=0&id=139a9ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139a9ed0",
  null
  
)

export default component.exports